<template>
  <div class="blog-card-container">
    <template v-if="article">
      <div class="meta-container">
        <span class="meta">Post: {{article.post}}</span>
        <span class="meta">Author: {{article.author}}</span>
        <span class="meta" v-if="article.tags && article.tags.length > 0">Tags: <span class="tag" v-for="(tag, ti) in article.tags" :key="ti">{{tag}}</span></span>
      </div>
      <h2 v-if="article.title">{{article.title}}</h2>
      <template v-if="article.type == 'parts'">
        <div class="part-button"
          @click="partsIndex = pi"
          :class="pi==partsIndex ? 'active' : ''"
          v-for="(part, pi) in article.parts"
          :key="pi">{{part.title ? `P${pi+1}：${part.title}` : `P${pi+1}`}}</div>
      </template>

      <div class="markdown-body" v-html="summary"></div>
      <div class="actions" v-if="article.md">阅读全文</div>
    </template>
  </div>
</template>

<script>
import * as marked from 'marked'

export default {
  props: ['article'],
  data: function () {
    return {
      partsIndex: 0,
    }
  },
  computed: {
    summary() {
      let theArticle = this.article
      if (!theArticle) return ''

      if (theArticle.type == 'parts') {
        theArticle = theArticle.parts[this.partsIndex]
      }

      let theSummary = theArticle.summary
      if (!theSummary) return '' 

      // 使用markdown进行内容渲染
      if (theArticle.summaryCompiler === 'md') {
        return marked.parse(theSummary)
      }

      // 把单字符串型内容拼接为合法array
      if (typeof theSummary == 'string') {
        theSummary = [theSummary]
      }
      if (!Array.isArray(theSummary)) return String(theSummary)
      return theSummary.map(p => p ? `<p>${p}</p>` : '<br/>').join('\n')
    }
  },
  mounted() {
    this.partsIndex = this.article.partIndex || 0
  }
}
</script>

<style lang="less" scoped>
.blog-card-container {
  font-family: sans-serif;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  padding: 1.2em 2em;
  margin-bottom: var(--gap-size);
  box-shadow: 0 1px 2px rgba(33,33,33,.2);
  max-width: 720px;

  & .meta-container {
    color: gray;
    & .meta {
      font-size: 12px;
      margin-right: 1em;
    }

    span.tag {
      padding: 2px 5px;
      background-color: #efefef;
      margin-right: 5px;
    }
  }

  h2 {
    font-size: 24px;
    border-left: 3px solid #0781f4;
    padding: .3em;
    background-color: #0781f414;
  }

  p {
    padding: 0;
    margin: 1em 0;
    line-height: 1.8;
  }

  .markdown-body {
    margin: 10px 0;
    font-size: 14px;
  }

  .part-button {
    display: inline-block;
    margin: 2px;
    padding: .3em .5em;
    background-color: #ecf5fe;
    color: #628cb3;
    border: 1px solid #ecf5fe;
    cursor: pointer;
  }
  .part-button.active {
    color: #004a8f;
    border-color: #628cb3;
  }
}

@media screen and (max-width: 550px) {
  .blog-card-container {
    padding: 1.2em var(--gap-size);
    margin-left: calc(var(--gap-size) * -1);
    margin-right: calc(var(--gap-size) * -1);

    font-size: 16px;

    & .meta-container {
      & .meta {
        display: block;
        line-height: 1.5;
        font-size: 14px;
      }
      span.tag {
        font-size: 12px;
      }
    }

    h2 {
      font-size: 20px;
    }

    p {
      line-height: 1.5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/blog/BlogCard.vue